/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type InitiateAdyenTerminalPaymentV2Request,
    InitiateAdyenTerminalPaymentV2RequestFromJSON,
    InitiateAdyenTerminalPaymentV2RequestToJSON,
} from '../models/InitiateAdyenTerminalPaymentV2Request';
import {
    type InitiateNetsTerminalPaymentV2Request,
    InitiateNetsTerminalPaymentV2RequestFromJSON,
    InitiateNetsTerminalPaymentV2RequestToJSON,
} from '../models/InitiateNetsTerminalPaymentV2Request';
import {
    type InitiatePaymentV2Response,
    InitiatePaymentV2ResponseFromJSON,
    InitiatePaymentV2ResponseToJSON,
} from '../models/InitiatePaymentV2Response';
import {
    type InitiateSoftpayAppSwitchPaymentRequest,
    InitiateSoftpayAppSwitchPaymentRequestFromJSON,
    InitiateSoftpayAppSwitchPaymentRequestToJSON,
} from '../models/InitiateSoftpayAppSwitchPaymentRequest';
import {
    type InitiateSoftpayCloudPaymentV2Request,
    InitiateSoftpayCloudPaymentV2RequestFromJSON,
    InitiateSoftpayCloudPaymentV2RequestToJSON,
} from '../models/InitiateSoftpayCloudPaymentV2Request';
import {
    type InitiateUnintegratedPaymentRequest,
    InitiateUnintegratedPaymentRequestFromJSON,
    InitiateUnintegratedPaymentRequestToJSON,
} from '../models/InitiateUnintegratedPaymentRequest';

export interface InitiateAdyenTerminalPayment1Request {
    initiateAdyenTerminalPaymentV2Request: InitiateAdyenTerminalPaymentV2Request;
}

export interface InitiateNetsTerminalPaymentRequest {
    initiateNetsTerminalPaymentV2Request: InitiateNetsTerminalPaymentV2Request;
}

export interface InitiateSoftpayCloudPaymentRequest {
    initiateSoftpayCloudPaymentV2Request: InitiateSoftpayCloudPaymentV2Request;
}

export interface InitiateSoftpayTerminalPaymentRequest {
    initiateSoftpayAppSwitchPaymentRequest: InitiateSoftpayAppSwitchPaymentRequest;
}

export interface InitiateUnintegratedPaymentOperationRequest {
    initiateUnintegratedPaymentRequest: InitiateUnintegratedPaymentRequest;
}

/**
 * 
 */
export class PaymentV2ControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for initiateAdyenTerminalPayment1 without sending the request
     */
    async initiateAdyenTerminalPayment1RequestOpts(requestParameters: InitiateAdyenTerminalPayment1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateAdyenTerminalPaymentV2Request'] == null) {
            throw new runtime.RequiredError(
                'initiateAdyenTerminalPaymentV2Request',
                'Required parameter "initiateAdyenTerminalPaymentV2Request" was null or undefined when calling initiateAdyenTerminalPayment1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v2/inhouse/payments/terminal/adyen`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateAdyenTerminalPaymentV2RequestToJSON(requestParameters['initiateAdyenTerminalPaymentV2Request']),
        };
    }

    /**
     */
    async initiateAdyenTerminalPayment1Raw(requestParameters: InitiateAdyenTerminalPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateAdyenTerminalPayment1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateAdyenTerminalPayment1(requestParameters: InitiateAdyenTerminalPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateAdyenTerminalPayment1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateNetsTerminalPayment without sending the request
     */
    async initiateNetsTerminalPaymentRequestOpts(requestParameters: InitiateNetsTerminalPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateNetsTerminalPaymentV2Request'] == null) {
            throw new runtime.RequiredError(
                'initiateNetsTerminalPaymentV2Request',
                'Required parameter "initiateNetsTerminalPaymentV2Request" was null or undefined when calling initiateNetsTerminalPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v2/inhouse/payments/terminal/nets`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateNetsTerminalPaymentV2RequestToJSON(requestParameters['initiateNetsTerminalPaymentV2Request']),
        };
    }

    /**
     */
    async initiateNetsTerminalPaymentRaw(requestParameters: InitiateNetsTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateNetsTerminalPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateNetsTerminalPayment(requestParameters: InitiateNetsTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateNetsTerminalPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateSoftpayCloudPayment without sending the request
     */
    async initiateSoftpayCloudPaymentRequestOpts(requestParameters: InitiateSoftpayCloudPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateSoftpayCloudPaymentV2Request'] == null) {
            throw new runtime.RequiredError(
                'initiateSoftpayCloudPaymentV2Request',
                'Required parameter "initiateSoftpayCloudPaymentV2Request" was null or undefined when calling initiateSoftpayCloudPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v2/inhouse/payments/terminal/softpay/cloud`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateSoftpayCloudPaymentV2RequestToJSON(requestParameters['initiateSoftpayCloudPaymentV2Request']),
        };
    }

    /**
     */
    async initiateSoftpayCloudPaymentRaw(requestParameters: InitiateSoftpayCloudPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateSoftpayCloudPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateSoftpayCloudPayment(requestParameters: InitiateSoftpayCloudPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateSoftpayCloudPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateSoftpayTerminalPayment without sending the request
     */
    async initiateSoftpayTerminalPaymentRequestOpts(requestParameters: InitiateSoftpayTerminalPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateSoftpayAppSwitchPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'initiateSoftpayAppSwitchPaymentRequest',
                'Required parameter "initiateSoftpayAppSwitchPaymentRequest" was null or undefined when calling initiateSoftpayTerminalPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v2/inhouse/payments/terminal/softpay/app-switch`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateSoftpayAppSwitchPaymentRequestToJSON(requestParameters['initiateSoftpayAppSwitchPaymentRequest']),
        };
    }

    /**
     */
    async initiateSoftpayTerminalPaymentRaw(requestParameters: InitiateSoftpayTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateSoftpayTerminalPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateSoftpayTerminalPayment(requestParameters: InitiateSoftpayTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateSoftpayTerminalPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateUnintegratedPayment without sending the request
     */
    async initiateUnintegratedPaymentRequestOpts(requestParameters: InitiateUnintegratedPaymentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateUnintegratedPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'initiateUnintegratedPaymentRequest',
                'Required parameter "initiateUnintegratedPaymentRequest" was null or undefined when calling initiateUnintegratedPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v2/inhouse/payments/unintegrated`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateUnintegratedPaymentRequestToJSON(requestParameters['initiateUnintegratedPaymentRequest']),
        };
    }

    /**
     */
    async initiateUnintegratedPaymentRaw(requestParameters: InitiateUnintegratedPaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateUnintegratedPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateUnintegratedPayment(requestParameters: InitiateUnintegratedPaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateUnintegratedPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
